import { render, staticRenderFns } from "./BottomMenuCatalog.vue?vue&type=template&id=2477d018"
import script from "./BottomMenuCatalog.vue?vue&type=script&lang=js"
export * from "./BottomMenuCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports